// Centralized icons for the school panel: Lucide icons under the panel's
// historical names, so the call sites stay unchanged. Each one defaults to
// size 1em (the react-icons default these call sites were sized for); a
// `size` / `strokeWidth` / `className` passed in still wins.
import { createElement, forwardRef } from 'react';
import type { LucideIcon, LucideProps } from 'lucide-react';
import {
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  Bell,
  BookOpen,
  Bot,
  ChartLine,
  Check,
  ChevronDown,
  ChevronRight,
  CircleAlert,
  CircleCheck,
  CircleX,
  ClipboardList,
  Clock,
  Download,
  Eye,
  FileOutput,
  FileText,
  Filter,
  GraduationCap,
  Hourglass,
  Info,
  LayoutGrid,
  List,
  Lock,
  LogOut,
  Mail,
  Pencil,
  Phone,
  Plus,
  Presentation,
  RefreshCw,
  School,
  Search,
  Send,
  Settings,
  Shield,
  Trash2,
  TriangleAlert,
  Undo2,
  Upload,
  UserPlus,
  Users,
  WandSparkles,
  X,
} from 'lucide-react';

function em(Icon: LucideIcon) {
  const Sized = forwardRef<SVGSVGElement, LucideProps>((props, ref) => createElement(Icon, { size: '1em', ...props, ref }));
  Sized.displayName = Icon.displayName;
  return Sized;
}

export const FaThLarge = em(LayoutGrid);
export const FaUserGraduate = em(GraduationCap);
export const FaUserClock = em(Hourglass);
export const FaBell = em(Bell);
export const FaClipboardList = em(ClipboardList);
export const FaChalkboardTeacher = em(Presentation);
export const FaBookOpen = em(BookOpen);
export const FaUsers = em(Users);
export const FaFileAlt = em(FileText);
export const FaChartLine = em(ChartLine);
export const FaShieldAlt = em(Shield);
export const FaCog = em(Settings);
export const FaCheck = em(Check);
export const FaTimes = em(X);
export const FaExclamationTriangle = em(TriangleAlert);
export const FaExclamationCircle = em(CircleAlert);
export const FaInfoCircle = em(Info);
export const FaPaperPlane = em(Send);
export const FaArrowUp = em(ArrowUp);
export const FaArrowDown = em(ArrowDown);
export const FaArrowRight = em(ArrowRight);
export const FaChevronRight = em(ChevronRight);
export const FaChevronDown = em(ChevronDown);
export const FaDownload = em(Download);
export const FaPhone = em(Phone);
export const FaTrash = em(Trash2);
export const FaSignOutAlt = em(LogOut);
export const FaSearch = em(Search);
export const FaPlus = em(Plus);
export const FaEnvelope = em(Mail);
export const FaTelegramPlane = em(Send);
export const FaCheckCircle = em(CircleCheck);
export const FaTimesCircle = em(CircleX);
export const FaPen = em(Pencil);
export const FaExchangeAlt = em(ArrowLeftRight);
export const FaRobot = em(Bot);
export const FaFileExport = em(FileOutput);
export const FaClock = em(Clock);
export const FaUndo = em(Undo2);
export const FaEye = em(Eye);
export const FaLock = em(Lock);
export const FaArrowLeft = em(ArrowLeft);
export const FaSync = em(RefreshCw);
export const FaFilter = em(Filter);
export const FaUserPlus = em(UserPlus);
export const FaUpload = em(Upload);
export const FaMagic = em(WandSparkles);
export const FaList = em(List);
export const FaSchool = em(School);
